import { ServiceType } from "@agroyaar/sdk";
import { getLightShades } from "../../../utils/report-color";

type NoteBoxProps = {
  children: React.ReactNode;

  serviceType?: ServiceType;
};

const NoteBox = ({ children, serviceType }: NoteBoxProps) => {
  const { lighter, normal } = getLightShades(serviceType ?? "CROPPING_PATTERN");
  return (
    <div
      className="p-4  border-[2px]  rounded-xl my-4"
      style={{ backgroundColor: lighter, borderColor: normal }}
    >
      <p className="leading-[30px] text-[18px] !font-[B-Nazanin]">{children}</p>
    </div>
  );
};

export default NoteBox;
